import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { useDebounce } from 'ahooks'
import { Empty, Input, Spin, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { useGetKnowledgeGroupsQuery } from '@/generated/graphql'
import { routes } from '@/routes'

import { KnowledgeCatalog } from './knowledge-catalog/knowledge-catalog.component'
import { KnowledgeGroupCreateUpdateModal } from './knowledge-modal/knowledge-group-create-edit-modal.component'
import s from './knowledge.module.less'

export const KnowledgeSidebar: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const [search, setSearch] = React.useState<string>('')
  const debouncedSearch = useDebounce(search, { wait: 500 })

  const { data: searchGroupData, loading } = useGetKnowledgeGroupsQuery({
    skip: !debouncedSearch,
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache',
    variables: {
      search: debouncedSearch,
      pagination: {
        last: 2000, // 获取所有群组信息
      },
    },
  })

  const knowledgeGroups = searchGroupData
    ? searchGroupData.knowledge.groups.edges
        .slice()
        .reverse()
        .map(({ node }) => node)
    : []

  const searchedItems = (
    <div>
      {knowledgeGroups.map((knowledgeGroup) => (
        <div
          className={s.item}
          key={knowledgeGroup.knowledgeGroupId}
          onClick={() => {
            setSearch('')
            history.push(routes.knowledgebase.category(knowledgeGroup.knowledgeGroupId))
          }}
        >
          <span>{knowledgeGroup.name}</span>
        </div>
      ))}
    </div>
  )

  const searchedResult = loading ? (
    <div style={{ padding: '0 40px', width: '100%', display: 'flex', justifyContent: 'center' }}>
      <Spin size='large' delay={300} />
    </div>
  ) : searchGroupData && knowledgeGroups.length === 0 ? (
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='无符合条件的知识目录' />
  ) : (
    searchedItems
  )

  const searchInput = (
    <div className={s.search}>
      <Input
        prefix={<SearchOutlined />}
        value={search}
        placeholder={t('knowledge.searchCatalog')}
        onChange={(e) => setSearch(e.target.value)}
        allowClear
      />
    </div>
  )

  const header = !search && (
    <div className={s.title}>
      <Typography.Title style={{ marginBottom: 0 }} level={4}>
        {t('knowledge.catalog')}
      </Typography.Title>
      <KnowledgeGroupCreateUpdateModal>
        <PlusOutlined style={{ fontSize: 20, color: '#48bbb5', marginLeft: 8, marginTop: 2 }} />
      </KnowledgeGroupCreateUpdateModal>
    </div>
  )

  const content = <div className={s.tree}>{search ? searchedResult : <KnowledgeCatalog type='sidebar' />}</div>

  return (
    <div className={s.sidebar}>
      {searchInput}
      {header}
      {content}
    </div>
  )
}
